// Funcion asincrona que carga todas las coordenadas de la base de datos
export default async function cargaTodosPuntos () {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", "./Request/enc/cargaTodosPuntosCifrado.php");
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.onload = function () {
            if (xhr.status === 200) {
                const respuesta = JSON.parse(xhr.responseText);
                resolve(respuesta);
            }
            else {
                reject(new Error("Request failed. Returned status of " + xhr.status));
            }
        };
        xhr.send(`puntos=1`);
    });
}
